import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeFromFilter, updateFilter } from "../../store/slices/filterSlice";

const Fluorescent = () => {
  const fluorescentRange = [
    { label: "SL", value: "SL" },
    { label: "N", value: "N" },
    { label: "S", value: "S" },
    { label: "VSL", value: "VSL" },
    { label: "Very Strong", value: "VERY STRONG" },
    { label: "Strong", value: "STRONG" },
    { label: "Medium", value: "MEDIUM" },
    { label: "Faint", value: "FAINT" },
    { label: "None", value: "NONE" },
  ];
  const dispatch = useDispatch();
  const filterSelect = useSelector((state) => state?.filter);
  const handleAddFilter = (value) => {
    dispatch(updateFilter({ key: "fluorescent", value: value }));
  };
  const handleRemoveFilter = (value) => {
    dispatch(removeFromFilter({ key: "fluorescent", value: value }));
  };
  return (
    <div className="w-100">
      <label className="filter-main-label">Fluorescent</label>
      <div className="filter-bg-container fluorescent-range range-outer-container">
        {fluorescentRange.map((item) => {
          return (
            <div
              className={`range-item ${
                filterSelect?.fluorescent?.includes(item?.value) ? "active" : ""
              }`}
              onClick={() =>
                filterSelect?.fluorescent?.includes(item?.value)
                  ? handleRemoveFilter(item?.value)
                  : handleAddFilter(item?.value)
              }
            >
              {item?.label}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Fluorescent;
